import { AppModule } from 'app/module';
import { mediaQueries } from 'util/mediaQueries';
import 'module/hr/main';
import 'module/icon/main';
import Template from './template.hbs';
import './styles.scss';

export class CompanyValueItem extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            groupHeader: '.m-companyValueItem__groupHeader--moreContent',
            title: '.m-companyValueItem__title',
            description: '.m-companyValueItem__description',
        };
    }

    getPropsFromDom() {
        return {
            title: this.dom.title ? this.dom.title.innerText : '',
            description: this.dom.description ? this.dom.description.innerHTML : '',
            color: this.dom.el.getAttribute('data-color'),
            open: this.dom.groupHeader
                ? this.dom.groupHeader.classList.contains('m-companyValueItem__groupHeader--open') : false,
        };
    }

    domEvents() {
        if (this.dom.groupHeader) {
            this.dom.groupHeader.addEventListener('click', () => this.changedAccordion());
        }
    }

    changedAccordion() {
        if (mediaQueries.isMobile()) {
            const { open } = this.props;
            this.events.emit('closeAllValues');
            this.updateProps({ open: !open }, true);
        }
    }
}
